export const decodeBr = s => 'string' === typeof s ?
    s.replace(/<br\s*\/?>/ig, '\n')
    :
    s
